var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMasks(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M57.3803 19C57.3803 19 42.1287 34.2717 16 35.2387C16.0183 35.2962 27.84 69.0758 49.1355 68.9897C50.8229 68.9801 52.4646 68.3386 53.7394 67.18C69.844 52.5786 57.3803 19 57.3803 19Z",
    stroke: "#EF9071",
    strokeWidth: 1.49802,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M28.3262 48.2722C28.3262 48.2722 33.0494 45.6293 39.0198 44.0781C39.0198 44.0781 36.8004 39.2231 31.8663 41.1574C26.9322 43.0918 28.3262 48.2722 28.3262 48.2722Z",
    stroke: "#EF9071",
    strokeWidth: 1.49802,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M45.6417 41.4734C45.6417 41.4734 50.3648 38.8307 56.3353 37.2795C56.3353 37.2795 54.1158 32.4249 49.1817 34.3591C44.2477 36.2933 45.6417 41.4734 45.6417 41.4734Z",
    stroke: "#EF9071",
    strokeWidth: 1.49802,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M53.9408 50.3481C53.9408 50.3481 47.0349 54.1305 38.3682 56.4574C38.3682 56.4574 41.413 63.0071 48.594 60.1919C55.7842 57.3671 53.9408 50.3481 53.9408 50.3481Z",
    stroke: "#EF9071",
    strokeWidth: 1.49802,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M55.4365 69.2113C74.7235 59.713 71.4586 23.8647 71.4586 23.8647C71.4586 23.8647 68.3495 25.5978 62.9294 27.2064",
    stroke: "#EF9071",
    strokeWidth: 1.49802,
    strokeMiterlimit: 10
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasks);
export default __webpack_public_path__ + "static/media/masks.be911ed6cdef31614a6d2499e9cfd4fe.svg";
export { ForwardRef as ReactComponent };